module.exports = __webpack_public_path__ + "img/drops-wins.d63bf954.png";